const ALLOWED_ENVIRONMENTS = ["local", "dev", "stage", "prod", "demo", "agent"] as const;

type AnalyticsEnvironment = (typeof ALLOWED_ENVIRONMENTS)[number];

const isAnalyticsEnvironment = (value: string): value is AnalyticsEnvironment =>
  (ALLOWED_ENVIRONMENTS as readonly string[]).includes(value);

const MODE_TO_ENVIRONMENT: Record<string, AnalyticsEnvironment> = {
  development: "local",
  production: "prod",
  test: "dev",
};

const normalizeEnvironment = (rawValue: string | undefined | null): AnalyticsEnvironment => {
  if (!rawValue) {
    return "local";
  }

  const normalized = rawValue.toLowerCase();

  if (isAnalyticsEnvironment(normalized)) {
    return normalized;
  }

  if (normalized in MODE_TO_ENVIRONMENT) {
    return MODE_TO_ENVIRONMENT[normalized];
  }

  return "local";
};

export const getAnalyticsEnvironment = (): AnalyticsEnvironment => {
  const rawEnv = import.meta.env.VITE_ENV ?? import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE;
  return normalizeEnvironment(rawEnv);
};

export const isLocalAnalyticsEnvironment = (): boolean => getAnalyticsEnvironment() === "local";
